module.exports = __webpack_public_path__ + "img/ill_block_4.3fa73eff.png";